import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { AuthLayout } from 'shared/layout'
import { type RegisterStore } from 'pages/register/ui/Register'
import { SignUpForm } from './SignUpForm/SignUpForm'
import { RightContent } from './RightContent/RightContent'

import styles from './styles.module.scss'

type IStep1Props = {
  store: RegisterStore
}

export const StepSignUp: FC<IStep1Props> = observer(({ store }) => {
  return (
    <AuthLayout
      title='Start your 14-day free trial'
      subtitle='Get started with business texting and calling for free today'
      form={<SignUpForm store={store} />}
      formClassnames={styles.form}
      rightContent={<RightContent />}
      coupon={store.couponTitle}
    />
  )
})

export default StepSignUp
